module.exports = __webpack_public_path__ + "static/media/LeaseIcon.b43f0fc5.svg";